import React, { useContext, useState, useEffect, useRef } from "react";
import { useCookies } from "react-cookie";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { Layout } from "../Layout";
import { Duration } from "luxon";
import {
  TimeContext,
  EventContext,
  CountdownSmall as Countdown,
  SSOButton,
  TextReminder,
  AnalyticsContext,
  VideoModal,
} from "Components";
import checkMark from "Images/checkMark.png";
import AdImg2 from "Images/AdImg2.png";
import AdImg3 from "Images/AdImg3.png";
import AdImg4 from "Images/AdImg4.png";
import { Select } from "Components/Fields/Field/Select";
import { useMediaQuery } from "Hooks/useMediaQuery";

export const RegisterLayout = React.memo(
  ({
    onSuccess,
    postCampaign,
    registered,
    postSweeps,
    postSweeps2,
    preCampaign,
  }) => {
    const { time } = useContext(TimeContext);
    const { event } = useContext(EventContext);
    const { logClick, logVideoAction, logLeadSubmission } = useContext(
      AnalyticsContext
    );
    const [cookies, setCookie] = useCookies();
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({});
    const [video, setVideo] = useState(null);
    const isDesktop = useMediaQuery("(min-width: 950px)");

    const formScreen = useRef(null);
    const [eventFired, setEventFired] = useState(false);
    const params = new URLSearchParams(window.location.search);
    const utm_source = params.get("utm_source");
    useEffect(() => {
      if (utm_source === "oauth" && !eventFired) {
        console.log("Firing form submit");
        setEventFired(true);
        logLeadSubmission({ formPart: 0 });
      }
    }, []);

    let RegFormContent;
    let HeroContent;
    let LiveStreamContent;

    const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
    const storageDirectory = event.storageDirectory;

    let insertImage = isDesktop
      ? event?.backgrounds?.hero?.path
      : event?.backgrounds?.hero?.pathMobile;

    let registeredImage = isDesktop
      ? event?.backgrounds?.registered?.path
      : event?.backgrounds?.registered?.pathMobile;

    const {
      logo: preLogo,
      heading: preHeading,
      body: preBody,
    } = event?.preCampaign;

    let preCampaignLogo = `${api}/o/${storageDirectory}%2F${preLogo}?alt=media`;
    let headerLogo = `${api}/o/${storageDirectory}%2F${event?.logos?.header?.path}?alt=media`;
    let headerStreamLogo = `${api}/o/${storageDirectory}%2F${event?.logos?.header?.pathStream}?alt=media`;
    let heroImg = `${api}/o/${storageDirectory}%2F${insertImage}?alt=media`;
    let streamHeroImg = `${api}/o/${storageDirectory}%2F${event?.backgrounds?.hero?.pathStream}?alt=media`;
    let signUpImg = `${api}/o/${storageDirectory}%2F${event?.backgrounds?.signUp?.path}?alt=media`;
    let registeredImg = `${api}/o/${storageDirectory}%2F${registeredImage}?alt=media`;
    let desktopImage = `${api}/o/${storageDirectory}%2F${event?.register?.artistImageDesktop?.path}?alt=media`;
    let mobileImage = `${api}/o/${storageDirectory}%2F${event?.register?.artistImageMobile?.path}?alt=media`;
    let postCampaignBg = `${api}/o/${storageDirectory}%2F${event?.backgrounds?.registration}?alt=media`;

    const { videoLink: ctaVideoLink } = event.register.callToActions.primary;

    const { shows } = event?.register;

    const headerLogoLink = event.logos.header.link;

    const startDate = event.start.toFormat("LLLL d");

    const linkClickHandler = (url, label) => {
      logClick({
        label: label,
        url: url,
      });
    };

    const handleSuccess = (admin, token, formPart, email) => {
      onSuccess(admin, token, formPart);
      if (formPart === 1) {
        setCookie("email", email, { maxAge: 31622400 });
        setFormData({ email });
      }
    };

    const setModalVisible = (bool, video) => {
      setVideo(video);
      setOpen(bool);
      logVideoAction({
        bool,
        videoLink: video,
        videoTitle: "Hero Video",
      });
    };

    const scrollToSection = (elementRef) => {
      elementRef.current.scrollIntoView();
    };

    if (postCampaign) {
      RegFormContent = (
        <>
          <ClosedHeading>
            {ReactHtmlParser(event.postShow.closedHeading)}
          </ClosedHeading>
          <ClosedBody>{ReactHtmlParser(event.postShow.closedBody)}</ClosedBody>
        </>
      );
    } else if (cookies?.formPart == 2 || registered) {
      const {
        heading,
        subHeading,
        body,
        countdownHeading,
        eventTime,
      } = event.register.content.part2;

      const timeToStart =
        time < event.start &&
        Duration.fromMillis(event.start - time).shiftTo(
          "days",
          "hours",
          "minutes",
          "seconds",
          "milliseconds"
        );

      const timer = {
        label: countdownHeading,
        days: timeToStart.days,
        hours: timeToStart.hours,
        minutes: timeToStart.minutes,
        seconds: timeToStart.seconds,
      };

      RegFormContent = (
        <>
          <HeadingUnderline>
            {heading && <Heading>{ReactHtmlParser(heading)}</Heading>}
          </HeadingUnderline>
          {subHeading && <SubHeading>{ReactHtmlParser(subHeading)}</SubHeading>}

          {/* create event date/time object */}

          {body && <Body>{ReactHtmlParser(body)}</Body>}
          {/* <SmallCountdown>
            <Countdown {...timer} />
          </SmallCountdown> */}
          <TextReminder buttonText={"Get a Text Reminder"} />
        </>
      );
    } else {
      const { heading, subHeading, eventTime, button } =
        // } = postSweeps ? event.register. :
        event.register.content.part1;

      const selectOptions =
        // ?.filter((show) => show?.date?.toMillis() > time?.toMillis())
        shows?.map((show, index) => {
          let fields = {
            id: show.id,
            text: show.location,
            date: show.date,
            disabled: show?.date?.toMillis() < time?.toMillis(),
          };
          return fields;
        }) ?? [];

      let isEnabled = !!formData && Object.keys(formData).length > 0;

      RegFormContent = (
        <FormItemContainer>
          {heading && <Heading>{ReactHtmlParser(heading)}</Heading>}
          {subHeading && <SubHeading>{ReactHtmlParser(subHeading)}</SubHeading>}
          <Select
            onChange={(value) => setFormData(value)}
            field={{ name: "concertSelection", options: selectOptions }}
            value={formData.concertSelection}
          />
          <StyledSSOButton
            buttonText={button}
            disabled={!isEnabled}
            preSSO
            preWriteValue={formData}
          />
          <RulesLink
            ref={formScreen}
            href="rules"
            target="_blank"
            rel="noopener noreferrer"
            class="uppercase"
          >
            Sweepstakes Rules
          </RulesLink>
          {/* <Login>
            Already have an AARP.org account?{" "}
            <StyledSSOButton buttonText="Log in" isLogin /> to your account to
            RSVP.
          </Login>
          <Blurb>
            <span>This event is FREE, but you must RSVP in advance.</span>
            <br />
            <StyledSSOButton buttonText="Log in" isLogin /> to your AARP.org
            account or <StyledSSOButton buttonText="register" /> for AARP.org
            today to RSVP.
            <br />
            AARP membership is NOT required.
          </Blurb> */}
        </FormItemContainer>
      );
    }

    HeroContent = (
      <Container>
        <HeroHeadline>
          Register for AARP e-swag and connect with AARP at upcoming Alan
          Jackson concerts.
        </HeroHeadline>
        <HeroText>
          AARP is a sponsor of Alan Jackson’s{" "}
          <Italic>Last Call: One More For The Road Tour </Italic> in connection
          with our mission to celebrate and support veterans, military service
          members, and their families who are vital to our country’s identity.
          We support our veterans and their families with information on career
          support, caregiving resources, community connections, and more.
        </HeroText>
        <ScrollButton onClick={() => scrollToSection(formScreen)}>
          Register Below
        </ScrollButton>
      </Container>
    );

    if (registered && !postSweeps2 && !postSweeps) {
      HeroContent = (
        <Container>
          <HeroHeadline>Thank you! </HeroHeadline>
          <HeroText>
            If you entered the sweepstakes for a chance to win tickets to an
            upcoming AARP sponsored Alan Jackson concert, you’ll be notified if
            you’re a winner.
          </HeroText>
          <HeroSubHeading>
            You’re also registered for an AARP Virtual Performance with Alan
            Jackson to commemorate Veterans Day on November 11, 2022.
          </HeroSubHeading>
          <HeroText>
            There will also be a special appearance by actor-humanitarian and
            AARP Ambassador for Veterans and Military Families, Gary Sinise.
          </HeroText>
        </Container>
      );
    } else if (postSweeps2) {
      HeroContent = (
        <Container>
          <HeroHeadline>Sorry You Missed It!</HeroHeadline>
          <HeroText>
            The sweepstakes to win tickets to an upcoming AARP sponsored Alan
            Jackson concert is over.
          </HeroText>
          <HeroSubHeading>
            But, you can RSVP for an AARP Virtual Performance with Alan Jackson
            to commemorate Veterans Day on November 11, 2022.
          </HeroSubHeading>
          <HeroText>
            There will also be a special appearance by actor-humanitarian and
            AARP Ambassador for Veterans and Military Families, Gary Sinise.
          </HeroText>
          {registered ? (
            <Link
              forward
              href="https://aarpconcerts.org/alan-jackson/"
              onClick={() =>
                linkClickHandler(
                  "https://aarpconcerts.org/alan-jackson/",
                  "Forward"
                )
              }
              target="_self"
              rel="noopener noreferrer"
            >
              {" "}
              Concert Access{" "}
            </Link>
          ) : (
            <StyledSSOButton buttonText="RSVP" rsvp postSweeps />
          )}
        </Container>
      );
    }

    if (postSweeps && registered) {
      LiveStreamContent = (
        <Container>
          <StreamHeadline>
            You're Registered!
            <span stream>
              An AARP Virtual Performance featuring Alan Jackson to commemorate
              Veterans Day with a special appearance by actor-humanitarian and
              AARP Ambassador for Veterans and Military Families, Gary Sinise.
            </span>
          </StreamHeadline>
          <StreamSubHeadline livestream={postSweeps}>
            We look forward to you joining us on <br></br>November 11th at 8
            p.m. (EST) | 7 p.m. (CST)
          </StreamSubHeadline>
        </Container>
      );
    } else if (postSweeps) {
      LiveStreamContent = (
        <Container>
          <StreamHeadline>
            Join us for an AARP Virtual Performance with Alan Jackson to
            commemorate Veterans Day
            <span>
              <span className="add-on">
                with a special appearance by actor-humanitarian and AARP
                Ambassador for Veterans and Military Families, Gary Sinise.
              </span>
              <DateContainer>
                November 11th{" "}
                <TimeContainer>
                  <div></div>8 p.m. (EST) <div>7 p.m. (CST) </div>
                </TimeContainer>
              </DateContainer>
              <StyledSSOButton
                buttonText="RSVP HERE"
                rsvp
                postSweeps
                livestream
              />
            </span>
          </StreamHeadline>
          {/* <HeroText> */}
          <StreamSubHeadline>
            <Login>
              Already have an AARP.org account?{" "}
              <StyledSSOButton stream buttonText="Log in" isLogin postSweeps />{" "}
              to your account to RSVP.
            </Login>
            <Blurb>
              <span>This event is FREE, but you must RSVP in advance.</span>
              <br />
              <StyledSSOButton
                stream
                buttonText="Log in"
                isLogin
                postSweeps
              />{" "}
              to your AARP.org account or{" "}
              <StyledSSOButton stream buttonText="register" postSweeps /> for
              AARP.org today to RSVP.
              <br />
              AARP membership is NOT required.
            </Blurb>
          </StreamSubHeadline>
          {/* </HeroText> */}
        </Container>
      );
    }

    const { countdownHeading, eventTime } = event.register.content.part2;

    const timeToStart =
      time < event.start &&
      Duration.fromMillis(event.start - time).shiftTo(
        "days",
        "hours",
        "minutes",
        "seconds",
        "milliseconds"
      );

    const timer = {
      label: countdownHeading,
      days: timeToStart.days,
      hours: timeToStart.hours,
      minutes: timeToStart.minutes,
      seconds: timeToStart.seconds,
    };

    return (
      <Layout
        registration
        showHeader={false}
        heroContent={false}
        postSweeps={postSweeps}
        noPadding
        showFooter
        showFooterTop
        expandFooterTop={postCampaign}
      >
        {/* {preCampaign ? (
          <PreContent>
            <Link
              preCampaign
              href={headerLogoLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={linkClickHandler}
            >
              <Logo src={preCampaignLogo} />
            </Link>
            {preHeading && (
              <Heading preCampaign>{ReactHtmlParser(preHeading)}</Heading>
            )}
            {preBody && <BodySignUp>{ReactHtmlParser(preBody)}</BodySignUp>}
          </PreContent>
        )  */}
        {postCampaign ? (
          <PreContent>
            <Link
              preCampaign
              href={headerLogoLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => linkClickHandler(headerLogoLink, "Header Logo")}
            >
              <Logo src={preCampaignLogo} />
            </Link>
            {preHeading && (
              <Heading preCampaign>{ReactHtmlParser(preHeading)}</Heading>
            )}
            {preBody && <BodySignUp>{ReactHtmlParser(preBody)}</BodySignUp>}
          </PreContent>
        ) : (
          <Content livestream={postSweeps}>
            <Link
              livestream={postSweeps}
              href={headerLogoLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => linkClickHandler(headerLogoLink, "Header Logo")}
            >
              <Logo
                livestream={postSweeps}
                src={postSweeps ? headerStreamLogo : headerLogo}
              />
            </Link>
            {registered && postSweeps && (
              <SmallCountdown>
                <Countdown {...timer} />
              </SmallCountdown>
            )}

            {postSweeps ? (
              <ArtistContent livestream={postSweeps}>
                <StreamHeroAside>{LiveStreamContent}</StreamHeroAside>
                <StreamContainer>
                  <StreamHero
                    src={streamHeroImg}
                    onClick={() => {
                      setModalVisible(true, ctaVideoLink);
                      linkClickHandler("Hero Video", "Hero Video");
                    }}
                    alt="artist image"
                  />
                </StreamContainer>
              </ArtistContent>
            ) : (
              <ArtistContent postSweeps={postSweeps2}>
                <HeroAside>{HeroContent}</HeroAside>
                <Hero src={heroImg} alt="artist image" />
              </ArtistContent>
            )}

            {!postSweeps && !registered && !postSweeps2 && (
              <ContentPadding>
                <SignUpContainer>
                  <SignUpContent>
                    <ContainerPadding>
                      {/* <HeadingSignUp>
                        When you sign up for AARP e-swag by logging into your
                        AARP.org account or creating one free
                      </HeadingSignUp> */}
                      <BodySignUp style={{ textAlign: "left", padding: 0 }}>
                        When you sign up for AARP e-swag by logging into your
                        AARP.org account or creating one free, you’ll be
                        automatically registered for an AARP Virtual Performance
                        featuring Alan Jackson on Veterans Day, celebrating the
                        sacrifices of veterans.
                        <br></br>
                        <br></br>
                        Your AARP e-swag will also include the opportunity to:
                      </BodySignUp>
                      <SignUpGridContainer>
                        <CheckIcon>
                          <img src={checkMark} alt="checkmark" />
                        </CheckIcon>
                        <SignUpText>
                          Enter for a chance to win two tickets to an upcoming
                          live Alan Jackson concert sponsored by AARP
                        </SignUpText>
                      </SignUpGridContainer>
                      <SignUpGridContainer>
                        <CheckIcon>
                          <img src={checkMark} alt="checkmark" />
                        </CheckIcon>
                        <SignUpText>
                          Select the Alan Jackson songs you would like to hear
                          during the AARP Virtual Performance
                        </SignUpText>
                      </SignUpGridContainer>
                      <BodySignUp style={{ textAlign: "left", padding: 0 }}>
                        Also, receive links to information about AARP and its
                        work.
                      </BodySignUp>
                    </ContainerPadding>
                  </SignUpContent>
                  <ImageContainer>
                    <SignUpImage
                      src={signUpImg}
                      alt="artist playing guitar image"
                    />
                  </ImageContainer>
                </SignUpContainer>
                <RegisterContainer>
                  <FormContent>{RegFormContent}</FormContent>
                </RegisterContainer>
                {/* <AdLayout>
              <Hero src={AdImg} alt="artist image" />
            </AdLayout> */}
              </ContentPadding>
            )}

            {(registered || (postSweeps && registered)) && (
              <ContentPadding livestream={postSweeps}>
                <SignUpImage src={registeredImg} alt="artist concert" />
                <SongButton
                  href="https://alanjackson.settheset.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() =>
                    linkClickHandler(
                      "https://alanjackson.settheset.com",
                      "STS Button"
                    )
                  }
                >
                  Pick Your Favorite Songs
                </SongButton>
              </ContentPadding>
            )}
          </Content>
        )}

        {(registered || (postSweeps2 && !postSweeps)) && (
          <AdLayout>
            <Heading>
              AARP works to help your money, health and <br></br>happiness live
              as long as you do.
            </Heading>
            <AdGridContainer>
              {/* <AdText>
                <AdImg src={AdImg1} alt="ad helping elderly" />
                <h4>Brain Health</h4>
                <p>
                  AARP studies show that both listening to and making music have
                  all kinds of beneficial effects. Music can be used to boost
                  movement and mood. And it can transport you back to a place in
                  time in your memory.
                  <br></br>
                  <br></br>
                  <a
                    href="https://www.stayingsharp.org/music"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.stayingsharp.org/music
                  </a>
                </p>
              </AdText> */}
              <AdText>
                <AdImg src={AdImg2} alt="ad helping elderly" />
                <h4>Veterans</h4>
                <p>
                  AARP is especially proud to serve nearly six million United
                  States veterans, military and their families with information,
                  discounts, resources, money tools and more.
                  <br></br>
                  <br></br>
                  <a
                    href="https://www.aarp.org/home-family/voices/veterans/?cmp=RDRCT-MIM-FRD-MAR2021_VETERANS&intcmp=LP-BRD-AJACKSON-2022"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      linkClickHandler(
                        "https://www.aarp.org/home-family/voices/veterans/?cmp=RDRCT-MIM-FRD-MAR2021_VETERANS&intcmp=LP-BRD-AJACKSON-2022",
                        "Veterans"
                      )
                    }
                  >
                    www.aarp.org/veterans
                  </a>
                </p>
              </AdText>
              <AdText>
                <AdImg src={AdImg3} alt="ad helping elderly" />
                <h4>Caregiving</h4>
                <p>
                  AARP has information for those either just beginning their
                  caregiving journey or caregivers who are looking for more
                  support and resources online.
                  <br></br>
                  <br></br>
                  <a
                    href="https://www.aarp.org/caregiving/basics/?cmp=RDRCT-MIM-CAREGIVING-MAR2022&intcmp=LP-BRD-AJACKSON-2022"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      linkClickHandler(
                        "https://www.aarp.org/caregiving/basics/?cmp=RDRCT-MIM-CAREGIVING-MAR2022&intcmp=LP-BRD-AJACKSON-2022",
                        "Caregiving"
                      )
                    }
                  >
                    {" "}
                    www.aarp.org/caregiving
                  </a>
                </p>
              </AdText>
              <AdText>
                <AdImg src={AdImg4} alt="ad helping elderly" />
                <h4>Fraud prevention</h4>
                <p>
                  AARP Fraud Watch Network™ has free, fraud prevention resources
                  for all. Sign up for our Watchdog Alerts to learn how to spot
                  and avoid scams and stay informed.
                  <br></br>
                  <br></br>
                  <a
                    href="https://www.aarp.org/money/scams-fraud/about-fraud-watch-network.html?cmp=RDRCT-MIM-FRD-MAR2021&intcmp=LP-BRD-AJACKSON-2022"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      linkClickHandler(
                        "https://www.aarp.org/money/scams-fraud/about-fraud-watch-network.html?cmp=RDRCT-MIM-FRD-MAR2021&intcmp=LP-BRD-AJACKSON-2022",
                        "Fraud prevention"
                      )
                    }
                  >
                    www.aarp.org/aboutfwn
                  </a>
                </p>
              </AdText>
            </AdGridContainer>
          </AdLayout>
        )}

        <VideoModal
          size="large"
          open={open}
          setOpen={setModalVisible}
          path={ctaVideoLink}
          autoplay={true}
        />
      </Layout>
    );
  }
);

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  background-color: #ea1300;
  position: relative;

  ${(props) => props.livestream && "background-color: white"};
`;
const ContentPadding = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 80%;
  margin: 50px auto;
  position: relative;

  ${(props) => props.livestream && "width: 100%; margin: 0 auto"};

  @media (max-width: 950px) {
    width: 100%;
  }
`;

const PreContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 50%;
  align-self: flex-start;
  background-color: white;
  padding: 50px 0 350px 150px;

  @media (max-width: 950px) {
    width: 80%;
    padding: 30px 0 50px 0;
    margin: 0 auto;
  }
`;

const HeroAside = styled.div`
  display: flex;
  flex-direction: column;
  width: 45%;
  color: white;
  padding: 0px 5%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
  height: 100%;
  justify-content: center;
  margin-top: -100px;

  @media (max-width: 950px) {
    width: 100%;
  }
`;

const StreamHeroAside = styled.div`
  display: flex;
  flex: 1;
  flex-basis: 50%;
  /* margin-top: -100px; */
  flex-direction: column;
  color: black;
  /* padding: 0 5% 8% 8%; */
  padding: 0 5% 0 5%;
  z-index: 15;
  justify-content: center;

  @media (max-width: 950px) {
    width: 100%;
    padding: 0 15% 0 5%;
  }
`;

const StreamContainer = styled.div`
  display: flex;
  flex: 1 0 50%;
  /* flex-basis: 50%; */
  justify-content: center;

  @media (max-width: 950px) {
    width: 100%;
  }
`;

const Hero = styled.img`
  height: 100%;
  position: absolute;
  right: 0;
  z-index: 1;

  @media (max-width: 950px) {
    position: unset;
    height: unset;
    width: 100%;
  }
`;

const StreamHero = styled.img`
  width: 100%;
  z-index: 1;

  @media (max-width: 950px) {
  }
`;

const RegisterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: 50px 70px;
`;

const AdLayout = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 90%;
  padding: 50px 5vw;

  @media (max-width: 950px) {
    padding: 40px;

    & > h2 {
      font-size: 1.8rem;
      padding: 20px;
    }
  }
`;

const AdGridContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin: 0 auto;

  @media (max-width: 950px) {
    flex-direction: column;
  }
`;

const AdText = styled.div`
  font-size: clamp(0.7rem, 1.05vw, 2vw);
  line-height: 120%;
  font-weight: 400;
  flex: 1;
  margin: 20px;

  & > p > a {
    color: #ea1300;
    font-size: clamp(0.7rem, 1.05vw, 2vw);
  }

  @media (max-width: 950px) {
    font-size: 1rem;

    & > h4 {
      font-size: 1.2rem;
    }
  }
`;

const AdImg = styled.img`
  width: 100%;
  margin-bottom: 15px;
`;
const FormItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

// ======== ARTIST IMAGE / RIGHT SIDE ======== //

const ArtistContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  background-color: black;
  height: max(45vw, 50vh);

  ${(props) => props.postSweeps && "margin-bottom: 50px;"};
  ${(props) =>
    props.livestream &&
    " background-color: transparent; height: unset;  margin-top: -100px;"};

  @media (max-width: 950px) {
    flex-direction: column-reverse;
    height: 100%;
    ${(props) => props.postSweeps && "margin-bottom: 0;"};

    ${(props) => props.livestream && "flex-direction: column; margin-top: 0;"};
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: 35vh;

  @media (max-width: 950px) {
    max-height: unset;
    margin: 0 15px 25px 0;
  }
`;

const ContainerPadding = styled.div`
  max-width: 550px;
  margin: 0 auto;
  padding: 50px;

  @media (min-width: 1750px) {
    max-width: 650px;
  }

  @media (max-width: 950px) {
    padding: 10px;
  }
`;

const HeroHeadline = styled.h1`
  font-size: clamp(1.4rem, 2vw, 4.5vw);
  line-height: 120%;
  padding: 0 1rem;

  @media (max-width: 950px) {
    font-size: 1.8rem;
    margin-top: 30px;
  }
`;

const StreamHeadline = styled.h1`
  font-size: clamp(1.4rem, 2vw, 2.4rem);
  line-height: 130%;
  color: #ea1300;
  padding-right: 5vw;

  & > span {
    display: block;
    color: black;
    font-weight: 500;
    font-size: clamp(1.1rem, 1.4vw, 4vw);
    margin-top: 25px;
    line-height: 120%;

    @media (max-width: 950px) {
      line-height: 150%;
    }
  }

  @media (max-width: 950px) {
    font-size: 1.7rem;
    margin-top: 30px;

  /* & > span {
      ${(props) => props.stream && "color: white;"}
    } */
  }

  & > span .add-on {
    display: block;
    color: black;
    font-weight: 500;
    font-size: clamp(1rem, 1.3vw, 3vw);
    margin-top: -20px;
    line-height: 120%;

    @media (max-width: 950px) {
      line-height: 150%;
    }
  }
`;

const StreamSubHeadline = styled.h1`
  font-size: clamp(1.1rem, 1.3vw, 2.5rem);
  line-height: 120%;
  color: black;
  font-weight: 400;

  & > span {
    color: #ea1300;
    display: block;
    font-weight: 600;
    font-size: clamp(1rem, 1.3vw, 2.5rem);
  }
  ${(props) =>
    props.livestream &&
    "color: #ea1300; font-weight: 600;  font-size: clamp(1.2rem, 1.4vw, 2.5vw)"};

  @media (max-width: 950px) {
    font-size: 1.4rem;
    margin-top: 20px;

    ${(props) => props.livestream && ""};
  }
`;

const DateContainer = styled.div`
  font-weight: 600;
  display: flex;
  flex-direction: row;
  margin: 10px 0 20px 0;
  align-items: center;

  @media (max-width: 950px) {
    font-size: 1.7rem;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 40px;
  }
`;

const TimeContainer = styled.div`
  border-left: 1px solid red;
  padding-left: 10px;
  margin-left: 10px;

  @media (max-width: 950px) {
    border-left: none;
    padding-left: 0px;
    margin-left: 0px;
  }
`;

const HeroSubHeading = styled.h1`
  font-size: clamp(0.9rem, 1.3vw, 2vw);
  line-height: 120%;
  padding: 0 3.3rem 0 1rem;
  font-weight: 600;
  color: white;

  @media (max-width: 950px) {
    font-size: 1.3rem;
  }
`;

const HeroText = styled.p`
  padding: 0 5rem 0 1rem;
  font-size: clamp(0.7rem, 1.1rem, 1vw);

  @media (max-width: 950px) {
    font-size: 1rem;
  }
`;

const Italic = styled.span`
  font-style: italic;
  margin-right: 5px;
`;

const ImageContainer = styled.div`
  display: flex;
  flex: 0 1 50%;
`;

const SignUpImage = styled.img`
  object-fit: cover;
  position: center;
  width: 100%;
`;

const SignUpContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 50px;
  /* max-height: 60vw; */
  overflow: hidden;

  @media (max-width: 950px) {
    flex-direction: column;
  }
`;

const SignUpContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  /* width: 50%; */
  /* max-width: 50%; */
  background-color: white;
  /* padding: 60px 6vw; */
  text-align: left;
  justify-content: center;

  @media (max-width: 950px) {
    padding: 50px;
  }
`;

const BodySignUp = styled.div`
  /* font-size: clamp(1vw, 0.9rem, 3vw); */
  font-size: clamp(0.9rem, 1.3vw, 1.6rem);
  /* font-size: 1vw; */
  margin-bottom: 20px;
`;
const SignUpText = styled.div`
  font-size: clamp(0.9rem, 1.3vw, 1.6rem);
  /* font-size: 1.1vw; */
  line-height: 120%;
  font-weight: 600;
  margin-bottom: 20px;

  @media (max-width: 950px) {
    line-height: 150%;
  }
`;

const HeadingUnderline = styled.div`
  width: 80%;
  align-items: center;
  border-bottom: 1px solid red;
  margin-bottom: 20px;
`;

const Heading = styled.h2`
  font-size: clamp(1.4rem, 2vw, 4.5vw);
  line-height: 1.2;
  margin-bottom: 24px;

  ${(props) =>
    props.preCampaign
      ? "color: red; text-align: left;"
      : "color: black; text-align: center;"};

  span {
    font-weight: 300;
    @media only screen and ${(props) => props.theme.maxMedia.small} {
      font-size: 25px;
      display: block;
    }
  }
`;

const SignUpGridContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const CheckIcon = styled.div`
  padding: 5px 2vw 20px 0;

  @media (max-width: 950px) {
    padding: 5px 30px 30px 0;
  }
`;

const HeadingSignUp = styled.h2`
  font-size: clamp(1.4rem, 2vw, 4.5vw);
  line-height: 120%;
  line-height: 1.2;
  margin-bottom: 24px;
  color: black;
  text-align: left;
`;

const SubHeading = styled.h3`
  font-size: 1.1rem;
  line-height: 1.2;
  margin-bottom: 24px;
  color: black;
  text-align: center;
  padding: 0 50px;
  font-weight: 400;

  @media (max-width: 950px) {
    padding: 0;
  }
`;

const Link = styled.a`
  ${(props) =>
    props.preCampaign ? "margin: 30px 0" : "margin: 30px 0 30px 10vw"};

  @media (max-width: 950px) {
    ${(props) => props.livestream && "margin: 30px 10px 10px  4vw;"}

    ${(props) => props.forward && " width: 80%; padding: 5px 30px; "}
  }

  ${(props) => props.livestream && "margin-top: 50px;"}

  ${(props) =>
    props.forward &&
    " display: block; width: 60%; margin: 25px 0 25px 20px; background-color: #ea1300; color: white; border-radius: 25px; border: 3px solid #ea1300; cursor: pointer; text-transform: none; text-decoration: none; font-size: 1rem; padding: 5px 60px; text-align: center; font-weight: 600;"}
`;

const Logo = styled.img`
  width: max(10%, 170px);

  ${(props) => props.livestream && "width: max(15%, 200px);"}

  @media (max-width: 950px) {
    ${(props) => props.livestream && "width: 150px; "}
  }
`;

const RulesLink = styled.a`
  text-decoration: none;
  text-transform: uppercase;
  color: black;
`;
const OverlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const OverlayImage = styled.img`
  width: clamp(50px, 15vw, 100px);
  cursor: pointer;
`;

// ======== CONTENT / LEFT SIDE ======== //

const Blurb = styled.h3`
  font-size: clamp(0.7rem, 1vw, 2.5rem);
  font-weight: 400;
  line-height: 1.4;
  color: #ea1300;
  span {
    font-size: clamp(0.7rem, 1vw, 2.5rem);
    font-weight: 600;
  }

  @media (max-width: 950px) {
    font-size: 1.3rem;

    & > span {
      font-size: 1.5rem;
    }
  }
`;

const StyledSSOButton = styled(SSOButton)`
  margin: 25px 0;
  background-color: #ea1300;
  color: white;
  border-radius: 25px;
  /* border: 3px solid #ea1300; */
  padding: inherit;
  cursor: pointer;
  text-transform: none;
  font-size: 1.2rem;
  padding: 5px 60px;
  text-align: center;
  font-weight: 600;

  ${(props) =>
    props.rsvp &&
    "width: 60%; font-size: max(1.2vw, 0.8rem); margin-left: 1.1vw"};

  @media (max-width: 950px) {
    ${(props) =>
      props.rsvp && "width: 90%; font-size: 1.3rem; margin: 10px auto"};

    ${(props) =>
      props.livestream &&
      "display: block; width: 100%;margin-left: -10px; max-width: 500px "};

    ${(props) => props.stream && "font-size: 1.3rem; "};
  }

  ${(props) =>
    props.disabled && "background-color: #d7d7d7; border-color: #f5f5f5"};

  &:hover {
    background-color: white;
    color: #ea1300;

    ${(props) =>
      props.disabled &&
      "background-color: #d7d7d7; border-color: #f5f5f5;  color: white; cursor: initial"};
  }

  &:focus {
    background-color: white;
    color: #ea1300;
  }

  ${(props) =>
    props.stream &&
    "color: #ea1300; background-color: transparent; border-radius: unset; text-transform: none; font-size: clamp(0.9rem, 1.1vw, 2.5rem); font-weight: 600; padding: 0; margin: 0; border: none;"};

  ${(props) => props.livestream && "margin: 0; "};
`;

const StyledSSOLink = styled(SSOButton)`
  border-radius: 25px;
  text-transform: none;
  font-size: 1rem;
  font-weight: 600;
`;

const ScrollButton = styled.div`
  margin: 20px 0 20px 20px;
  background-color: #ea1300;
  color: white;
  border-radius: 25px;
  border: 3px solid #ea1300;
  width: 50%;
  cursor: pointer;
  text-transform: none;
  font-size: max(0.8rem, 1vw);
  padding: 5px 30px;
  text-align: center;
  font-weight: 600;

  @media (max-width: 950px) {
    width: 80%;
  }

  /* &:hover {
    background-color: white;
    color: #ea1300;
  } */

  &:focus {
    background-color: white;
    color: #ea1300;
  }
`;

const SongButton = styled.a`
  position: absolute;
  top: 35%;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  font-size: max(1.1rem, 1.3vw);
  width: 30%;
  min-width: 250px;
  max-width: 350px;
  height: 10%;
  min-height: 40px;
  max-height: 50px;
  background-color: #ea1300;
  color: white;
  border-radius: 25px;
  border: 3px solid #ea1300;
  cursor: pointer;
  text-align: center;
  text-transform: none;
  padding-top: 3px;
  font-weight: 600;
  text-decoration: none;
  &:hover,
  &:focus {
    background-color: #ea1300;
    color: white;
  }

  @media (max-width: 950px) {
    border-radius: 50px;
    top: 35%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    font-size: 4vw;
    width: 70%;
    min-width: unset;
    max-width: unset;
    height: 9vw;
    min-height: unset;
    max-height: unset;
    text-align: center;
  }

  @media (min-width: 585px) and (max-width: 950px) {
    padding-top: 7px;
  }
`;

const Registration = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

// const Content = styled.div`
//   display: flex;
//   flex-direction: column;
// `;

const ContentContainer = styled.div`
  margin: 0 auto;
  padding: 25px 15px 50px;
  width: 100%;
  max-width: 650px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    max-width: unset;
    padding: 25px 0 25px 50px;
    max-width: 520px;
    min-height: 700px;
  }
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const ClosedHeading = styled(Heading)`
  ::after {
    display: block;
    content: "";
    width: 50%;
    border-bottom: 1px solid red;
    margin-top: 25px;
  }
`;

const Body = styled.p`
  font-weight: 100;
  margin-top: 0;
  text-align: center;
  padding: 0 40px;

  a,
  a:active,
  a:visited {
    color: inherit;
  }
`;

const ClosedBody = styled(Body)``;

const SmallCountdown = styled.div`
  width: max-content;
  position: absolute;
  z-index: 15;
  left: 30%;
  top: 50px;
  /* margin-top: 50px; */
  /* top: -90px; */
  /* left: 45%; */
  /* margin: 0; */

  @media (max-width: 950px) {
    top: 0px;
    left: unset;
    right: 5%;
    /* width: min-content;
    min-width: 350px; */

    /* margin-top: 100px; */
  }
`;

const EventInfo = styled.div`
  display: flex;
  flex-direction: row;
  font-size: clamp(16px, 6vw, 32px);
  font-weight: 600;
  width: 100%;
  line-height: 1.15;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: clamp(16px, 8vw, 24px);
  }
`;

const EventDate = styled.div`
  padding: 0 15px 0 0;
`;

const EventTime = styled.div`
  border-left: 1px solid #df2a2e;
  display: flex;
  flex-direction: column;
  padding: 0 0 0 15px;
`;

const Login = styled.p`
  a {
    color: #f11a00;
  }
`;

// ======== MODAL ======== //

// const VideoModal = styled(Modal)`
//   justify-content: center;
//   min-height: unset;
//   position: relative;

//   svg {
//     top: 10px;
//     right: 10px;
//   }
// `;

// const VideoModalContainer = styled.div`
//   padding-top: 56.25%;
//   position: relative;
// `;

// const Video = styled.iframe`
//   height: 100%;
//   position: absolute;
//   top: 0;
//   width: 100%;
//   border: 0;
// `;
